import React, { Fragment, useEffect, useState } from 'react'
import LoadingAbsolute from '../../LoadingAbsolute'
// import Header from '../../Header'
import { useLocation, useNavigate } from 'react-router-dom'
import InputDisabled from '../../InputDisabled'
import TheatreModal from './TheatreModal'
import ArrowDownSvg from '../../../assets/icons/ArrowDownSvg'
import InfoCircleGreenSvg from '../../../assets/icons/InfoCircleGreenSvg'
import DateModal from './DateModal'
import ProgressBar from './ProgressBar'
import ConditionsCheckBox from '../ApplicationsForm/ConditionsCheckBox'
import { Button } from 'reactstrap'
import TubitakWarningModal from '../ESporBasvuruForm/Modals/TubitakWarningModal'
import axios from 'axios'
import InputComp from '../../InputComp'
import Header from '../../Header'
import DynamicMessage from '../../DynamicMessage'

const TicketBuyPage = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [theatreModalOpen, setTheatreModalOpen] = useState(false)
  const [dateModalOpen, setDateModalOpen] = useState(false)
  const [checkbox, setCheckbox] = useState(false)

  const [theatreLabelClass, setTheatreLabelClass] = useState('selectLabel')
  const [theatreInputClass, setTheatreInputClass] = useState('selectInput')
  const [theatreDateLabelClass, setTheatreDateLabelClass] = useState('selectLabel')
  const [theatreDateInputClass, setTheatreDateInputClass] = useState('selectInput')

  const [selectedTheatre, setSelectedTheatre] = useState(null)
  const [selectedDate, setSelectedDate] = useState('')
  const [ages, setAges] = useState('')
  const [selectedDateId, setSelectedDateId] = useState('')
  const [selectedSeans, setSelectedSeans] = useState('')
  const [selectedSeansId, setSelectedSeansId] = useState('')

  const [labelName, setLabelName] = useState('')
  const [labelSurname, setLabelSurname] = useState('')
  const [etkinlikTuru, setEtkinlikTuru] = useState('')
  const [kisiTuru, setKisiTuru] = useState('')

  const [ticketBuyCount, setTicketBuyCount] = useState(null)
  const [kalanBiletSayisi, setKalanBiletSayisi] = useState(null)

  const [ticketCount, setTicketCount] = useState(0)

  const [sayi, setSayi] = useState(0)

  const [doluluk, setDoluluk] = useState(0)
  const [formData, setFormData] = useState({
    tc_no: '',
    adi: '',
    soyadi: '',
    dogum_tarihi: '',
  })

  // Çoklu çocuk formları için state
  const [childrenForms, setChildrenForms] = useState([
    { tc_no: '', adi: '', soyadi: '', dogum_tarihi: '' },
    { tc_no: '', adi: '', soyadi: '', dogum_tarihi: '' },
    { tc_no: '', adi: '', soyadi: '', dogum_tarihi: '' },
  ])

  const handleChange = (e) => {
    const { name, value } = e.target
    let formattedValue = value

    setFormData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }))
  }

  // Çocuk formları için değişiklik handler'ı
  const handleChildChange = (index, e) => {
    const { name, value } = e.target
    setChildrenForms((prev) => {
      const updated = [...prev]
      updated[index] = {
        ...updated[index],
        [name]: value,
      }
      return updated
    })
  }

  const [warningModalOpen, setWarningModalOpen] = useState({
    state: '',
    active: false,
    message: '',
  })

  const [data, setData] = useState(null)

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/etkinlik-bilet`, {
        params: {
          basvuru_id: state?.basvuru_id,
          token: JSON.parse(localStorage.getItem('token')),
        },
      })
      .then((res) => {
        console.log('res: ', res.data)
        setLoading(false)
        if (res.data.code === 200) {
          setData(res.data.data)
          setLabelName(res.data.adi)
          setLabelSurname(res.data.soyadi)
          setTicketCount(0)
        } else if (res.data.code === 400) {
          setWarningModalOpen({
            state: 'responseMessage',
            active: true,
            message: res.data.message,
          })
        }
      })
  }, [state])

  const onFinish = () => {
    if (!selectedTheatre) {
      setTheatreInputClass('unSelectInput')
      setTheatreLabelClass('unSelectLabel')
      return false
    } else {
      setTheatreInputClass('selectInput')
      setTheatreLabelClass('selectLabel')
    }

    if (selectedDate) {
      setTheatreDateInputClass('selectInput')
      setTheatreDateLabelClass('selectLabel')
    } else {
      setTheatreDateInputClass('unSelectInput')
      setTheatreDateLabelClass('unSelectLabel')
      return false
    }

    if (selectedTheatre && selectedDate && !selectedSeans) {
      setWarningModalOpen({ state: 'selectedSeans', active: true })
    } else if (!ticketBuyCount) {
      setWarningModalOpen({ state: 'ticketCount', active: true })
    } else if (!checkbox) {
      setWarningModalOpen({ state: 'checkbox', active: true })
    } else if (selectedTheatre && selectedDate && selectedSeans && checkbox && ticketBuyCount) {
      buyTicket()
    }
  }
  const buyTicket = () => {
    let route_data = {
      labelName: labelName,
      labelSurname: labelSurname,
      selectedTheatre: selectedTheatre?.theatre_name,
      selectedDate: selectedDate,
      selectedSeans: selectedSeans,
      ticketBuyCount: ticketBuyCount,
      kalanBiletSayisi: kalanBiletSayisi,
      ...state,
    }
    setLoading(true)

    // Bilet sayısına göre çocuk bilgilerini hazırla
    const childrenData = kisiTuru === 'COCUK' ? childrenForms.slice(0, ticketBuyCount) : formData

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/etkinlik-bilet`, {
        id: state?.basvuru_id,
        token: JSON.parse(localStorage.getItem('token')),
        tiyatro_gosterisi_id: selectedTheatre?.theatre_id,
        tiyatro_gosterisi_tarihi_id: selectedDateId,
        tiyatro_gosterisi_seans_id: selectedSeansId,
        bilet_adedi: ticketBuyCount,
        ikinci_kisi: childrenData,
      })
      .then((res) => {
        if (res?.data.code === 200) {
          navigate('/ticket-buy-success', {
            state: { ...route_data, bilet_no: res?.data.bilet_no, renderSuccessTitle: renderSuccessTitle(), renderSuccessSalon: renderSuccessSalon() },
          })
          setLoading(false)
        } else if (res?.data.code === 400) {
          setWarningModalOpen({
            state: 'responseMessage',
            active: true,
            message: res.data.message,
          })
          setLoading(false)
        }
      })
  }

  const renderGosteri = () => {
    let title = null
    const basvuruTuru = state?.basvuru_turu
    // Workshop gibi "Etkinlik" türündeki etkinlikler gösteri değil
    if (selectedTheatre?.etkinlik_turu === 'Etkinlik') {
      title = 'etkinlik'
    } else if (basvuruTuru === 'Etkinlik') {
      title = 'gösteri'
    } else if (basvuruTuru === 'Maç') {
      title = 'maç'
    }

    return title
  }

  const renderSuccessTitle = () => {
    let title = null
    const basvuruTuru = state?.basvuru_turu
    if (basvuruTuru === 'Etkinlik') {
      title = 'Etkinlik'
    } else if (basvuruTuru === 'Maç') {
      title = 'Maç'
    }

    return title
  }

  const renderSuccessSalon = () => {
    let title = null
    const basvuruTuru = state?.basvuru_turu
    if (basvuruTuru === 'Etkinlik') {
      title = 'salonda'
    } else if (basvuruTuru === 'Maç') {
      title = 'stadyumda'
    }

    return title
  }

  const RenderTitle = () => {
    let title = null
    const basvuruTuru = state?.basvuru_turu
    if (basvuruTuru === 'Etkinlik') {
      title = 'Etkinlik Seçiniz'
    } else if (basvuruTuru === 'Maç') {
      title = 'Maç Seçiniz'
    }

    return <div className={theatreLabelClass}>{title}</div>
  }

  const renderDate = () => {
    let date = null
    const basvuruTuru = state?.basvuru_turu
    if (basvuruTuru === 'Etkinlik') {
      date = 'Etkinlik Tarihi'
    } else if (basvuruTuru === 'Maç') {
      date = 'Maç Tarihi'
    }

    return date
  }

  const renderSession = () => {
    let session = null
    const basvuruTuru = state?.basvuru_turu
    if (basvuruTuru === 'Etkinlik') {
      session = 'Seans'
    } else if (basvuruTuru === 'Maç') {
      session = 'Maç Saati'
    }

    return session
  }

  const renderProgressBarTitle = () => {
    let title = null
    const basvuruTuru = state?.basvuru_turu
    if (basvuruTuru === 'Etkinlik') {
      title = null
    } else if (basvuruTuru === 'Maç') {
      // Panelde girilen "gösterilen kontenjan" (yoksa koltuk sayısı); doluluk gerçek kontenjana göre
      const seans = (selectedTheatre?.seans || []).flatMap((d) => d.hours || []).find((h) => h.hour_id === selectedSeansId)
      title = seans?.gosterilen_kontenjan ? `Bilet Tanımlama Yoğunluğu (${seans.gosterilen_kontenjan} Bilet İçin)` : 'Bilet Tanımlama Yoğunluğu'
    }

    return title
  }

  const renderProgressBarSubtitle = () => {
    let title = null
    const basvuruTuru = state?.basvuru_turu
    if (basvuruTuru === 'Etkinlik') {
      title = 'seans'
    } else if (basvuruTuru === 'Maç') {
      title = 'maç'
    }

    return title
  }

  return (
    <>
      {loading ? <LoadingAbsolute text={'Yükleniyor'} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
          }}
        >
          <Header onClick={() => navigate(-1)} />
        </div>

        <div className='userInfoDiv'>
          <div className='form-input-div'>
            <InputDisabled label={'Adınız'} value={labelName} />
          </div>

          <div className='form-input-div'>
            <InputDisabled label={'Soyadınız'} value={labelSurname} />
          </div>

          <div
            style={{
              marginTop: '0.5rem',
              width: '100%',
            }}
          >
            <RenderTitle />
            <div
              className={theatreInputClass}
              onClick={() => {
                setTheatreModalOpen(true)
                setSelectedTheatre(null)
                setTheatreInputClass('selectInput')
                setTheatreLabelClass('selectLabel')
                setSelectedDate(null)
                setSelectedDateId(null)
                setSelectedSeans('')
                setSelectedSeansId('')
                setTicketBuyCount(0)
                setSayi(0)
                setAges('')
                setEtkinlikTuru('')
                setKisiTuru('')
              }}
            >
              <div>{selectedTheatre ? selectedTheatre?.theatre_name : 'Seçiniz...'}</div>
              <ArrowDownSvg width={'1rem'} height={'1rem'} stroke={theatreInputClass === 'unSelectInput' ? 'red' : '#b5ccc2'} />
            </div>
          </div>
          {theatreInputClass === 'unSelectInput' && (
            <div
              style={{
                marginTop: '-0.3rem',
                marginLeft: '0.5rem',
                fontSize: '9px',
                color: 'red',
              }}
            >
              Bu Alan Zorunludur.
            </div>
          )}

          <>
            {selectedTheatre?.seans?.length === 1 ? (
              <InputDisabled style={{ margin: '-0.5rem 0 0 0' }} label={renderDate()} value={selectedTheatre?.seans[0].date} />
            ) : (
              <>
                <div
                  style={{
                    marginTop: '0.5rem',
                    width: '100%',
                  }}
                >
                  <div className={theatreDateLabelClass}>{renderDate()}</div>
                  <div
                    className={theatreDateInputClass}
                    style={{
                      pointerEvents: selectedTheatre ? 'auto' : 'none',
                      backgroundColor: selectedTheatre ? '#fff' : '#f1f1f1',
                    }}
                    onClick={() => {
                      setDateModalOpen(true)
                      setTheatreDateInputClass('selectInput')
                      setTheatreDateLabelClass('selectLabel')
                      setSelectedSeans('')
                      setSelectedSeansId('')
                    }}
                  >
                    <div>{selectedDate ? selectedDate?.split('-').reverse().join('-') : 'Seçiniz...'}</div> <ArrowDownSvg width={'1rem'} height={'1rem'} stroke={theatreDateInputClass === 'unSelectInput' ? 'red' : '#b5ccc2'} />
                  </div>
                </div>
              </>
            )}
            {theatreDateInputClass === 'unSelectInput' && (
              <div
                style={{
                  marginTop: '-0.3rem',
                  marginLeft: '0.5rem',
                  fontSize: '9px',
                  color: 'red',
                }}
              >
                Bu Alan Zorunludur.
              </div>
            )}
          </>

          {selectedDate && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: '-0.7rem',
              }}
            >
              <div className='label'>{renderSession()}</div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                }}
              >
                {selectedTheatre?.seans?.map(
                  (seans) =>
                    selectedDate === seans.date &&
                    seans.hours?.map((item) => (
                      <div
                        key={item.hour_id}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          // marginBottom: '0.3rem',
                        }}
                        onClick={() => {
                          setSayi(item.sayi)
                          setDoluluk(item.doluluk)
                          setSelectedSeans(item.hour)
                          setSelectedSeansId(item.hour_id)
                          setTicketCount(item.kalan_bilet < item.kalan_kullanim_hakki ? item.kalan_bilet : item.kalan_kullanim_hakki)
                          setKalanBiletSayisi(item.kalan_bilet)
                        }}
                      >
                        <>
                          <div className='checkboxBorder'>
                            <div
                              className='checkboxIn'
                              style={{
                                fontSize: '38px',
                                backgroundColor: selectedSeans === item.hour ? '#205c42' : '#fff',
                              }}
                            ></div>
                          </div>
                          <div className='checkboxLabel'>{item.hour}</div>
                        </>
                      </div>
                    ))
                )}
              </div>
            </div>
          )}
          {selectedSeans && <ProgressBar doluluk={selectedSeans ? doluluk : 0} title={renderProgressBarTitle()} subtitle={renderProgressBarSubtitle()} />}
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                marginTop: '-0.7rem',
              }}
            >
              {selectedTheatre && selectedDateId && selectedSeansId && (
                <>
                  <div className='label' style={{}}>
                    {'Almak İstediğiniz Bilet Sayısı'}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    {Array.from({ length: sayi ?? 4 }, (_, index) => index + 1)?.map((item) => (
                      <div
                        className='theaterTicketCount'
                        key={item}
                        onClick={() => ticketCount >= item && setTicketBuyCount(item)}
                        style={{
                          backgroundColor: ticketCount < item ? '#f1f1f1' : ticketBuyCount === item ? '#205c42' : '#fff',
                          color: ticketBuyCount !== item ? '#205c42' : '#fff',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            alignSelf: 'center',
                            justifyContent: 'center',
                            position: 'absolute',
                            top: '6px',
                            right: '6px',
                            width: '15px',
                            height: '15px',
                            border: '1px solid',
                            borderRadius: '100%',
                            borderColor: ticketBuyCount === item ? '#fff' : '#d4d4d4',
                          }}
                        >
                          {ticketCount >= item ? (
                            <div
                              style={{
                                display: 'flex',
                                width: '9px',
                                height: '9px',
                                borderRadius: '100%',
                                backgroundColor: '#fff',
                              }}
                            ></div>
                          ) : null}
                        </div>
                        <div>{`${item}`}</div>
                        <div>adet</div>
                      </div>
                    ))}
                  </div>
                </>
              )}
              {ticketBuyCount > 0 && selectedSeans && selectedSeans !== '' && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    margin: '1rem 0 0 0',
                    borderRadius: '5px',
                    backgroundColor: '#C8E6CF',
                    padding: '0.5rem 0.5rem',
                  }}
                >
                  <div style={{ padding: '0 1rem 0 0.5rem' }}>
                    <InfoCircleGreenSvg width={'1rem'} height={'1rem'} />
                  </div>
                  <div style={{ fontSize: '12px' }}>
                    Seçmiş olduğunuz {renderGosteri()}{' '}
                    <span>
                      <b>{selectedSeans} </b>
                    </span>
                    saatinde,{' '}
                    <span>
                      <b> {selectedTheatre?.place} </b>
                    </span>
                    adlı konumda gerçekleştirilecektir. Bu {renderGosteri()} için{' '}
                    <span>
                      <b>{ticketBuyCount} adet bilet </b>
                    </span>{' '}
                    alıyorsunuz.
                  </div>
                </div>
              )}

              {ticketBuyCount > 0 && selectedSeans && selectedSeans !== '' && (
                <>
                  {kisiTuru === 'KENDISI' && etkinlikTuru && (
                    <DynamicMessage
                      template='[etkinlik_turu_aciklama]'
                      variables={{
                        etkinlik_turu_aciklama: etkinlikTuru,
                      }}
                    />
                  )}
                  {kisiTuru === 'COCUK' && (
                    <DynamicMessage
                      template='[etkinlik_turu_aciklama] [yas] yaş arası çocuklar içindir.'
                      variables={{
                        etkinlik_turu_aciklama: etkinlikTuru,
                        yas: ages,
                      }}
                    />
                  )}
                  {kisiTuru === 'COCUK' && (
                    <Fragment>
                      <h6
                        style={{
                          marginTop: '1.25rem',
                          marginBottom: '-0.1rem',
                          marginLeft: '1rem',
                          fontSize: '12px',
                          color: '#205c42',
                        }}
                      >
                        Çocuk Bilgileri
                      </h6>
                      {Array.from({ length: Math.min(ticketBuyCount, 3) }, (_, index) => (
                        <Fragment key={index}>
                          {ticketBuyCount > 1 && (
                            <h6
                              style={{
                                marginTop: '1rem',
                                marginBottom: '0.5rem',
                                marginLeft: '1rem',
                                fontSize: '11px',
                                color: '#205c42',
                                fontWeight: '600',
                              }}
                            >
                              {index + 1}. Çocuk
                            </h6>
                          )}
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              borderRadius: '5px',
                              padding: '0.5rem 0.5rem',
                              gap: '10px',
                            }}
                          >
                            <div className='form-input-div'>
                              <InputComp type='text' name='tc_no' value={childrenForms[index].tc_no} label={'T.C. Kimlik No'} placeholder='T.C. Kimlik No' errorText={'Geçerli bir kimlik numarası giriniz'} onChange={(e) => handleChildChange(index, e)} />
                            </div>
                            <div className='form-input-div'>
                              <InputComp type='text' name='adi' value={childrenForms[index].adi} label={'Adı'} placeholder='Adı' errorText={'Geçerli bir adı giriniz'} onChange={(e) => handleChildChange(index, e)} />
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              borderRadius: '5px',
                              padding: '0.5rem 0.5rem',
                              gap: '10px',
                            }}
                          >
                            <div className='form-input-div'>
                              <InputComp type='text' name='soyadi' value={childrenForms[index].soyadi} label={'Soyadı'} placeholder='Soyadı' errorText={'Geçerli bir soyadı giriniz'} onChange={(e) => handleChildChange(index, e)} />
                            </div>
                            <div className='form-input-div'>
                              <InputComp type='text' name='dogum_tarihi' value={childrenForms[index].dogum_tarihi} label={'Doğum Tarihi'} placeholder='Doğum Tarihi' errorText={'Geçerli bir doğum tarihi giriniz'} mask='99/99/9999' onChange={(e) => handleChildChange(index, e)} />
                            </div>
                          </div>
                        </Fragment>
                      ))}
                    </Fragment>
                  )}
                </>
              )}

              <>
                {selectedTheatre ? (
                  <div>
                    <ConditionsCheckBox
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        margin: '1rem 0 0.5rem 0',
                      }}
                      checkbox={checkbox}
                      setCheckbox={setCheckbox}
                      basvuru_sartlari_title={selectedTheatre?.kvkk_baslik}
                      basvuru_sartlari_aciklama={selectedTheatre?.kvkk}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      margin: '1rem 0 0.5rem 0',
                    }}
                  ></div>
                )}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '300px',
                  }}
                >
                  <Button
                    block
                    className='tubitakTamamla'
                    onClick={onFinish}
                    style={{
                      backgroundColor: '#285843',
                      borderRadius: '20px',
                      padding: '0.6rem 0',
                    }}
                  >
                    Bilet Alma İşlemini Tamamla
                  </Button>
                </div>
              </>
            </div>
          </>
        </div>
      </div>
      <TheatreModal
        data={data}
        show={theatreModalOpen}
        onHide={() => setTheatreModalOpen(false)}
        setSelectedTheatre={setSelectedTheatre}
        setSelectedDate={setSelectedDate}
        setAges={setAges}
        setKisiTuru={setKisiTuru}
        setEtkinlikTuru={setEtkinlikTuru}
        setSelectedDateId={setSelectedDateId}
        setDoluluk={setDoluluk}
        setKalanBiletSayisi={setKalanBiletSayisi}
        setTicketCount={setTicketCount}
        setSelectedSeans={setSelectedSeans}
        setSayi={setSayi}
        setSelectedSeansId={setSelectedSeansId}
        setSchoolClass={() => {
          setTheatreInputClass('selectInput')
          setTheatreLabelClass('selectLabel')
        }}
      />
      {selectedTheatre?.seans ? (
        <DateModal
          data={selectedTheatre.seans}
          show={dateModalOpen}
          onHide={() => setDateModalOpen(false)}
          setSelectedDate={setSelectedDate}
          setSelectedDateId={setSelectedDateId}
          setDoluluk={setDoluluk}
          setSelectedSeans={setSelectedSeans}
          setSayi={setSayi}
          setSelectedSeansId={setSelectedSeansId}
          setTicketCount={setTicketCount}
          setKalanBiletSayisi={setKalanBiletSayisi}
          setSchoolClass={() => {
            setTheatreInputClass('selectInput')
            setTheatreLabelClass('selectLabel')
          }}
        />
      ) : null}

      <TubitakWarningModal show={warningModalOpen.active} onHide={() => setWarningModalOpen({ state: '', active: false })} state={warningModalOpen.state} message={warningModalOpen.message} />
    </>
  )
}

export default TicketBuyPage
